import React from 'react';
import { useMutation } from '@apollo/client';
import TrackerAddMealMutation from './TrackerAddMealMutation';
import TrackerQuery from '../Fetch/TrackerQuery';
import FetchUserMealsQuery from '../../UserMeals/Fetch/FetchUserMealsQuery';
import { formatIsoDate } from '../../../Helpers/dateFormatter';

interface ITrackerAddMealConnectorApolloProps {
  children: ({
    addMeal,
  }: {
    addMeal: (input: any, saveYourMeal: boolean) => Promise<any>;
  }) => React.ReactElement;
  post: any;
}

const TrackerAddMealConnectorApollo: React.FC<ITrackerAddMealConnectorApolloProps> = ({
  children,
  post,
}) => {
  const [addMealMutation] = useMutation(TrackerAddMealMutation);

  const addMeal = async (input: any, saveYourMeal: boolean) => {
    const response = await addMealMutation({
      variables: { input },
      awaitRefetchQueries: true,
      refetchQueries: input.dateTime
        ? [
            {
              query: TrackerQuery,
              variables: {
                date: formatIsoDate(new Date(input.dateTime)),
              },
            },
          ]
        : [{ query: FetchUserMealsQuery }],
    });

    // if not saving as user meal, reload the page
    if (post && !saveYourMeal) {
      post('reload');
    }

    return response.data.dailyTracker.addMeal;
  };
  return children({ addMeal });
};

export default TrackerAddMealConnectorApollo;
